<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">2</h2>
<p class="vers"><span>Wenn du</span> mir befiehlst zu
singen,<br class="calibre1"/>
scheint mir das Herz vor Stolz brechen<br class="calibre1"/>
zu wollen; ich schau in dein Antlitz, und<br class="calibre1"/>
Tränen kommen mir in das Auge. All das,<br class="calibre1"/>
was hart und mißtönig ist mir im Leben,<br class="calibre1"/>
zerschmilzt in eine süße Harmonie – und<br class="calibre1"/>
meine Anbetung breitet die Schwingen<br class="calibre1"/>
gleich einem frohen Vogel im Fluge über die See.</p>
<p class="vers">Ich weiß, mein Singen macht dir Freude,<br class="calibre1"/>
ich weiß, nur als Sänger werde ich vor<br class="calibre1"/>
dich gelassen.</p>
<p class="vers">Ich rühre mit dem Saume der
weitausgebreiteten<br class="calibre1"/>
Schwinge des Sangs deine<br class="calibre1"/>
Füße, die nie zu erreichen ich streben<br class="calibre1"/>
könnte.</p>
<p class="vers">Trunken von Freude des Singens vergeß<br class="calibre1"/>
ich mich ganz und nenne dich Freund,<br class="calibre1"/>
der du mein Herr bist. <a id="page5" title="JohannN/wedi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?196daa20